export function transformCamelCaseToSeparatedWords(string) {
  return string
    .split(/(?=[A-Z])/)
    .join(" ")
    .toUpperCase();
}
